import {
  AnalyticsSection,
  EmployerMemberCourse,
  EmployerMemberCredential,
  EmployerMemberSkill,
  EmployerProgram,
  EmployerProgramMember,
  MemberStatus,
} from '../models/employer.models';

export const MOCK_PROGRAMS: EmployerProgram[] = [
  {
    id: 'mba-exec-2024',
    name: 'MBA Executive (IE)',
    code: 'MBA-EXEC-2024',
    institution: 'IE Business School',
    startYear: 2024,
    endYear: 2026,
    status: 'active',
  },
  {
    id: 'msdl-2025',
    name: 'MSc Digital Transformation',
    code: 'MSDL-2025',
    institution: 'IE Business School',
    startYear: 2025,
    endYear: 2026,
    status: 'active',
  },
  {
    id: 'gep-2023',
    name: 'Global Executive Programme',
    code: 'GEP-2023',
    institution: 'IE Business School',
    startYear: 2023,
    endYear: 2025,
    status: 'completed',
  },
];

const MBA_COURSE_NAMES = ['Strategic Management', 'Corporate Finance', 'Decision Science', 'Entrepreneurship Lab', 'Leadership Elective'];

const MSDL_COURSE_NAMES = ['Digital Strategy', 'Data Foundations', 'Cloud Platforms', 'Innovation Sprint', 'AI for Business'];

const SKILL_POOL: { name: string; category: string }[] = [
  { name: 'Strategic Thinking', category: 'Strategy' },
  { name: 'Data-Driven Decision Making', category: 'Analytics' },
  { name: 'Stakeholder Management', category: 'Communication' },
  { name: 'Financial Modelling', category: 'Analytics' },
  { name: 'Change Leadership', category: 'Leadership' },
  { name: 'Innovation Design', category: 'Innovation' },
  { name: 'Public Speaking', category: 'Communication' },
  { name: 'Project Management', category: 'Operations' },
  { name: 'Team Leadership', category: 'Leadership' },
  { name: 'Venture Creation', category: 'Innovation' },
  { name: 'ESG Strategy', category: 'Strategy' },
  { name: 'Customer Empathy', category: 'Communication' },
  { name: 'Negotiation', category: 'Communication' },
  { name: 'Operational Excellence', category: 'Operations' },
];

interface MemberSeed {
  id: string;
  name: string;
  firstName: string;
  role: string;
  cohort: string;
  department: string;
  progress: number;
  skills: number;
  sparks: number;
  lastActive: string;
  enrolled: string;
  status: MemberStatus;
}

const MBA_SEEDS: MemberSeed[] = [
  {
    id: 'm1',
    name: 'Ahmed Bin Khalifa',
    firstName: 'Ahmed',
    role: 'VP',
    cohort: 'Sep 2024',
    department: 'Commercial',
    progress: 45,
    skills: 5,
    sparks: 412,
    lastActive: '4 weeks ago',
    enrolled: '2 Sep 2024',
    status: 'at-risk',
  },
  {
    id: 'm2',
    name: 'Aisha Al-Maktoum',
    firstName: 'Aisha',
    role: 'Director',
    cohort: 'Sep 2024',
    department: 'Customer Experience',
    progress: 91,
    skills: 14,
    sparks: 1240,
    lastActive: 'Today',
    enrolled: '2 Sep 2024',
    status: 'active',
  },
  {
    id: 'm3',
    name: 'Amna Al-Falasi',
    firstName: 'Amna',
    role: 'Head of',
    cohort: 'Sep 2024',
    department: 'Business Development',
    progress: 81,
    skills: 12,
    sparks: 1010,
    lastActive: 'Today',
    enrolled: '2 Sep 2024',
    status: 'active',
  },
  {
    id: 'm4',
    name: 'Bader Al-Suwaidi',
    firstName: 'Bader',
    role: 'Finance Lead',
    cohort: 'Sep 2024',
    department: 'Treasury',
    progress: 41,
    skills: 5,
    sparks: 460,
    lastActive: '5 days ago',
    enrolled: '2 Sep 2024',
    status: 'active',
  },
  {
    id: 'm5',
    name: 'Faisal Al-Ameri',
    firstName: 'Faisal',
    role: 'Senior Manager',
    cohort: 'Sep 2024',
    department: 'Finance',
    progress: 89,
    skills: 13,
    sparks: 1180,
    lastActive: 'Today',
    enrolled: '2 Sep 2024',
    status: 'active',
  },
  {
    id: 'm6',
    name: 'Fatima Al-Rashidi',
    firstName: 'Fatima',
    role: 'Senior Manager',
    cohort: 'Sep 2024',
    department: 'Digital & Cloud',
    progress: 65,
    skills: 8,
    sparks: 847,
    lastActive: 'Today',
    enrolled: '2 Sep 2024',
    status: 'active',
  },
  {
    id: 'm7',
    name: 'Ghada Al-Kaabi',
    firstName: 'Ghada',
    role: 'Director',
    cohort: 'Sep 2024',
    department: 'Sustainability',
    progress: 85,
    skills: 12,
    sparks: 1090,
    lastActive: 'Today',
    enrolled: '2 Sep 2024',
    status: 'active',
  },
  {
    id: 'm8',
    name: 'Hana Al-Otaibi',
    firstName: 'Hana',
    role: 'Manager',
    cohort: 'Sep 2024',
    department: 'Internal Audit',
    progress: 52,
    skills: 7,
    sparks: 612,
    lastActive: '3 days ago',
    enrolled: '2 Sep 2024',
    status: 'active',
  },
  {
    id: 'm9',
    name: 'Hind Al-Romaithi',
    firstName: 'Hind',
    role: 'CFO',
    cohort: 'Sep 2024',
    department: 'Finance',
    progress: 93,
    skills: 14,
    sparks: 1310,
    lastActive: 'Today',
    enrolled: '2 Sep 2024',
    status: 'active',
  },
  {
    id: 'm10',
    name: 'Humaid Al-Shaali',
    firstName: 'Humaid',
    role: 'VP',
    cohort: 'Sep 2024',
    department: 'Mergers & Acquisitions',
    progress: 69,
    skills: 9,
    sparks: 880,
    lastActive: 'Today',
    enrolled: '2 Sep 2024',
    status: 'active',
  },
  {
    id: 'm11',
    name: 'Khalid Al-Mansouri',
    firstName: 'Khalid',
    role: 'Manager',
    cohort: 'Jan 2025',
    department: 'Consulting',
    progress: 58,
    skills: 7,
    sparks: 704,
    lastActive: 'Yesterday',
    enrolled: '13 Jan 2025',
    status: 'active',
  },
  {
    id: 'm12',
    name: 'Lena Al-Hassan',
    firstName: 'Lena',
    role: 'Senior Consultant',
    cohort: 'Jan 2025',
    department: 'Strategy',
    progress: 71,
    skills: 9,
    sparks: 931,
    lastActive: 'Today',
    enrolled: '13 Jan 2025',
    status: 'active',
  },
  {
    id: 'm13',
    name: 'Maryam Al-Zubaidi',
    firstName: 'Maryam',
    role: 'Senior Analyst',
    cohort: 'Jan 2025',
    department: 'Risk Advisory',
    progress: 55,
    skills: 7,
    sparks: 612,
    lastActive: '2 days ago',
    enrolled: '13 Jan 2025',
    status: 'active',
  },
  {
    id: 'm14',
    name: 'Rakan Al-Ghamdi',
    firstName: 'Rakan',
    role: 'Director',
    cohort: 'Jan 2025',
    department: 'Financial Advisory',
    progress: 48,
    skills: 6,
    sparks: 544,
    lastActive: '4 days ago',
    enrolled: '13 Jan 2025',
    status: 'active',
  },
  {
    id: 'm15',
    name: 'Tariq Al-Rasheed',
    firstName: 'Tariq',
    role: 'Associate',
    cohort: 'Jan 2025',
    department: 'Technology',
    progress: 29,
    skills: 5,
    sparks: 318,
    lastActive: '3 weeks ago',
    enrolled: '13 Jan 2025',
    status: 'at-risk',
  },
];

const MSDL_SEEDS: MemberSeed[] = [
  {
    id: 'd1',
    name: 'Noura Al-Salem',
    firstName: 'Noura',
    role: 'Product Lead',
    cohort: 'Sep 2025',
    department: 'Digital',
    progress: 32,
    skills: 4,
    sparks: 240,
    lastActive: 'Yesterday',
    enrolled: '1 Sep 2025',
    status: 'active',
  },
  {
    id: 'd2',
    name: 'Sami Al-Otaibi',
    firstName: 'Sami',
    role: 'Data Engineer',
    cohort: 'Sep 2025',
    department: 'Data',
    progress: 28,
    skills: 3,
    sparks: 196,
    lastActive: '2 days ago',
    enrolled: '1 Sep 2025',
    status: 'active',
  },
];

function deriveCourses(courseNames: string[], progress: number): EmployerMemberCourse[] {
  // Distribute progress across courses: earlier courses are completed first
  const total = courseNames.length;
  const totalPctPool = progress * total;
  const result: EmployerMemberCourse[] = [];
  let remaining = totalPctPool;
  for (let i = 0; i < total; i++) {
    const take = Math.min(100, Math.max(0, Math.round(remaining)));
    result.push({ name: courseNames[i], pct: take });
    remaining -= take;
  }
  return result;
}

function deriveSkillsDetail(skillsCount: number, progress: number): EmployerMemberSkill[] {
  const n = Math.min(Math.max(skillsCount, 4), SKILL_POOL.length);
  // higher progress → more advanced levels
  const hiBand = progress >= 70 ? 4 : progress >= 40 ? 3 : 2;
  return SKILL_POOL.slice(0, n).map((s, i) => {
    const level = Math.max(1, hiBand - Math.floor(i / 3));
    const verified = i % 2 === 0;
    return { name: s.name, category: s.category, level, max: 5 + (verified ? 1 : 0) };
  });
}

function deriveCredentials(skillsCount: number, progress: number): EmployerMemberCredential[] {
  const count = progress >= 80 ? 3 : progress >= 50 ? 2 : progress >= 30 ? 1 : 0;
  const titles = ['Strategy & Leadership Badge', 'Finance Foundations Certificate', 'Innovation Practitioner'];
  const issuers = ['IE Business School', 'IE Business School', 'IE × Industry'];
  const dates = ['12 Mar 2025', '8 Jun 2025', '18 Sep 2025'];
  return Array.from({ length: count }, (_, i) => ({
    title: titles[i],
    issuer: issuers[i],
    date: dates[i],
  }));
}

function buildMember(seed: MemberSeed, courseNames: string[]): EmployerProgramMember {
  return {
    ...seed,
    courses: deriveCourses(courseNames, seed.progress),
    skillsDetail: deriveSkillsDetail(seed.skills, seed.progress),
    credentials: deriveCredentials(seed.skills, seed.progress),
  };
}

export const MOCK_MEMBERS: Record<string, EmployerProgramMember[]> = {
  'mba-exec-2024': MBA_SEEDS.map((s) => buildMember(s, MBA_COURSE_NAMES)),
  'msdl-2025': MSDL_SEEDS.map((s) => buildMember(s, MSDL_COURSE_NAMES)),
  'gep-2023': [],
};

export const ANALYTICS_SECTIONS: AnalyticsSection[] = [
  {
    id: 'cohort-comparison',
    label: 'Cohort Comparison',
    description: 'Compare cohorts on final grades, pre/post scores, or learning gain — per course as a line chart.',
  },
  {
    id: 'grade-distribution',
    label: 'Grade Distribution',
    description: 'Did students actually learn? See how scores shifted from start to finish, and which courses drove the most improvement.',
  },
  {
    id: 'course-table',
    label: 'Course Table',
    description:
      'What does each course look like by the numbers? Sort, filter and compare completion, grades, and engagement across all courses.',
  },
  {
    id: 'engagement',
    label: 'Engagement',
    description:
      'Are learners showing up? See platform activity over time, which courses are pulling them in, and who your most active learners are.',
  },
  {
    id: 'surveys',
    label: 'Survey Intelligence',
    description:
      'What do learners actually think? Connect your survey tool to see satisfaction scores, trends across cohorts, and course-level detail.',
  },
];
